function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 1440,
  height: 1028
}, React.createElement("rect", {
  width: 1440,
  height: 1028,
  fill: "#0D2CCC",
  fillOpacity: 0.26
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask0)"
}, React.createElement("path", {
  d: "M1160 801V683.808L1389 524V634.978L1160 801Z",
  fill: "#0D2CCC",
  fillOpacity: 0.1
}), React.createElement("path", {
  d: "M1160 1028V910.808L1389 751V861.978L1160 1028Z",
  fill: "#0D2CCC",
  fillOpacity: 0.1
}), React.createElement("path", {
  d: "M931 1077V959.808L1160 800V910.978L931 1077Z",
  fill: "#0D2CCC",
  fillOpacity: 0.1
}), React.createElement("path", {
  d: "M1389 754V636.808L1618 477V587.978L1389 754Z",
  fill: "#0D2CCC",
  fillOpacity: 0.1
}));

var SvgBackgroundpatternn = function SvgBackgroundpatternn(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 1440,
    height: 1028,
    viewBox: "0 0 1440 1028",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBackgroundpatternn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/backgroundpatternn.fd396cd9.svg";
export { ForwardRef as ReactComponent };